<mat-sidenav-container>
  <mat-sidenav [mode]="isLarge ? 'side' : 'over'" [opened]="isLarge" fixedInViewport class="darken" #sidenav>
    <mat-action-list>
      <a mat-list-item [href]="advToolsUrl + '/builder/' + reportCache.cache_key" matListItemTitle
        style="text-decoration: none;">
        <span matListItemTitle>Change Report</span>
        <mat-icon matListItemIcon>edit</mat-icon>
      </a>
      <button mat-list-item *ngIf="reportCache.is_live; else archiveTmpl" (click)="createArchive()">
        <span matListItemTitle>Create Archive</span>
        <mat-icon matListItemIcon>archive</mat-icon>
      </button>
      <button mat-list-item (click)="openTableDialog()">
        <span matListItemTitle>Change Tables</span>
        <mat-icon matListItemIcon>table_view</mat-icon>
      </button>
      <ng-template #archiveTmpl>
        <button mat-list-item (click)="deleteArchive()">
          <span matListItemTitle>Delete Archive</span>
          <mat-icon matListItemIcon color="warn">delete</mat-icon>
        </button>
      </ng-template>
      <button mat-list-item (click)="exportTables()">
        <span matListItemTitle>Excel Export</span>
        <mat-icon matListItemIcon>file_download</mat-icon>
      </button>
      <!-- <mat-icon svgIcon="ms-excel" matListItemIcon /> -->
    </mat-action-list>
    <mat-divider></mat-divider>
    <ls-collapse-links [paths]="navLinks" (openHelper)="showHelp($event)('main')"></ls-collapse-links>
  </mat-sidenav>
  <mat-sidenav-content>
    <header>
      <div>
        <button *ngIf="!isLarge" mat-icon-button (click)="sidenav.open()">
          <mat-icon>menu</mat-icon>
        </button>
        <a class="client-link" *ngIf="client" matRipple [href]="returnPortalUrl">
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-subtitle>Client</mat-card-subtitle>
              <mat-card-title>{{client.client_name}}</mat-card-title>
            </mat-card-header>
            <img mat-card-image *ngIf="client.logo_url" src="/assets/images{{ client.logo_url }}" alt="Client Logo" />
            <mat-card-content>
              <div class="concept" *ngIf="reportCache.report_type === 'concept_linescore'">
                <h4>Concept</h4>
                <p>{{ reportCache.text_labels.concept_text }}</p>
              </div>
            </mat-card-content>
          </mat-card>
        </a>
      </div>
      <span class="fill"></span>
      <div class="w-1/2">
        <ng-container *ngIf="reportCache">
          <h2>{{ reportCache.text_labels.survey_type }}</h2>
          <p class="mat-body-1">
            {{
            reportCache.text_labels.cell_number +
            " " +
            reportCache.text_labels.cell_name
            }}
          </p>
          <p class="mat-body-1">{{ reportCache.text_labels.run_date }}</p>
          <p class="mat-body-1">{{ reportCache.text_labels.author }}</p>
        </ng-container>
        <div>
          <button mat-raised-button color="primary" (click)="reRun()">
            <mat-icon>refresh</mat-icon>
            <span>Refresh</span>
          </button>
        </div>
        <span class="fill"></span>
      </div>
    </header>
    <mat-divider class="hidden md:block"></mat-divider>
    <main class="apply container mx-auto box-border px-4 max-w-screen-lg">
      <router-outlet></router-outlet>
    </main>
    <span class="fill"></span>
    <div class="floaty-scroll-btn">
      <button mat-fab class="mat-elevation-z0" (click)="scrollMe()">
        <mat-icon>expand_less</mat-icon>
      </button>
    </div>
    <footer>
      <ul>
        <li>About Us</li>
        <li>Privacy Policy</li>
        <li>Site Map</li>
        <li>User Guide for Clients</li>
      </ul>
    </footer>
  </mat-sidenav-content>
</mat-sidenav-container>